import clsx from 'clsx'
import Image from 'next/image'
import Link from '@/atoms/Link/Link'

/* assets */
import { ReactComponent as ArrowLeft } from 'public/assets/icons/arrow-right.svg'
import { ReactComponent as ChevronRight } from 'public/assets/icons/chevron-right.svg'
import BookSaved from 'public/assets/global-marketing-leaders/book-saved.png'

interface Props {
  className?: string
  title: string
  image: StrapiImageFile
  ctaTitle: string
  ctaLink: string
  description?: string
}

function AdCard({
  className,
  title,
  image,
  ctaTitle,
  ctaLink
}: Props): JSX.Element {
  return (
    <div
      className={clsx(
        className,
        'rounded-lg | py-14 px-8 | relative overflow-hidden'
      )}
    >
      <Image
        src="/assets/global-marketing-leaders/circle-triangle-speaker.svg"
        alt="circle-triangle-rotate"
        width={90}
        height={234}
        className="absolute top-0 right-0"
      />
      <Image
        src="/assets/global-marketing-leaders/pill-circle-speaker.svg"
        alt="pill-square-rotate"
        width={113}
        height={234}
        className="absolute left-0 bottom-0"
      />
      <div className="px-6">
        <div className="flex items-center text-blue-web-50 | pb-5 lg:pb-4">
          <Image
            src={BookSaved.src}
            alt="Book Saved E-Book"
            width={BookSaved.width}
            height={BookSaved.height}
            className="w-5 h-5"
          />
          <p className="font-body uppercase text-lg font-medium | ml-3">
            E-Book
          </p>
        </div>
        <h3 className="font-body uppercase text-2xl font-medium">{title}</h3>
      </div>
      <Image
        src={image.url}
        alt={image.alternativeText ?? ''}
        width={image.width}
        height={image.height}
        className="max-w-col-3 mx-auto mb-8"
      />
      <Link
        href={ctaLink}
        className="btn-primary btn-size-default | text-center | flex gap-1 | mx-auto | w-fit"
      >
        {ctaTitle}

        <ArrowLeft />
      </Link>
    </div>
  )
}

export function AdCardSimple({
  className,
  title,
  image,
  ctaTitle,
  ctaLink
}: Props): JSX.Element {
  return (
    <div
      className={clsx(
        className,
        'rounded-lg | flex flex-col items-center md:px-14 md:py-5 gap-6'
      )}
    >
      <h3 className="font-heading text-2xl">{title}</h3>
      <Image
        src={'/assets/influencer/images/free-template-3.png'}
        alt={image.alternativeText ?? ''}
        width={image.width}
        height={image.height}
        className="shadow-xl | w-full"
      />
      <Link
        href={ctaLink}
        className="btn-primary btn-size-default | text-center | flex | mx-auto | w-full"
      >
        {ctaTitle}

        <ArrowLeft />
      </Link>
    </div>
  )
}

export function HorizontalAdCard({
  className,
  title,
  description,
  image,
  ctaTitle,
  ctaLink
}: Props) {
  return (
    <div
      className={clsx(
        className,
        'rounded-2xl | flex justify-between shadow-high | overflow-hidden'
      )}
    >
      <div className="flex flex-col | pt-6 pb-4 pl-6">
        <h3 className="font-medium text-blue-web-90 text-sm md:text-lg | mb-4 md:mb-6">
          {title}
        </h3>
        <p className="text-xs md:text-lg text-gray-60">{description}</p>

        <Link href={ctaLink} className="flex items-center gap-2 | mt-auto">
          <p className="text-sm md:text-lg font-medium text-blue-web-50">
            {ctaTitle}
          </p>
          <ChevronRight className="text-blue-web-50" />
        </Link>
      </div>

      <div className="mb-[-12px] px-6 pt-6">
        <Image
          src={image.url ?? ''}
          alt={image.alternativeText ?? ''}
          width={image.width}
          height={image.height}
          className=""
        />
      </div>
    </div>
  )
}

export default AdCard
